import { useEffect } from "react";
import { useAsyncScript } from "library/hooks/useAsyncScript";
import { useProfile } from "library/hooks/auth/useProfile";
import { getRegional } from "library/getRegional";

const canUseDOM = !!window?.document?.createElement;

/**
 * 🐨 We need to be sure to add zE
 * settings when window object is present.
 * 🚨 canUseDOM will save any future SSR issues.
 * ref: https://github.com/B3nnyL/react-zendesk/blob/master/src/index.js
 * @param args: ref https://developer.zendesk.com/embeddables/docs/widget/core#prefill
 * @constructor
 */
export const ZendeskAPI = (...args) => {
  if (canUseDOM && window.zE) {
    window.zE.apply(null, args);
  }
};

export const Zendesk = () => {
  const isNZ = getRegional("code") === "NZ";
  const zendeskKey = isNZ
    ? "9ab57ecd-3d82-4e3d-ac97-cb366bc72b72"
    : "34f4d43c-fb78-460c-bfa9-258bf81fcaca";

  const status = useAsyncScript(
    `https://static.zdassets.com/ekr/snippet.js?key=${zendeskKey}`,
    "ze-snippet",
  );
  const { profile, isLoggedIn } = useProfile();
  const shouldPrefill = status === "ready" && isLoggedIn;

  useEffect(() => {
    if (shouldPrefill && !!profile?.email && !!profile?.name) {
      const data = {
        name: {
          value: profile?.name ?? "",
          readOnly: true,
        },
        email: {
          value: profile?.email ?? "",
          readOnly: true,
        },
      };

      ZendeskAPI("webWidget", "prefill", data);
    }
  }, [profile?.email, profile?.name, shouldPrefill]);

  return null;
};
